import { XStack, YStack } from '@/components/ui/layout/layout';

export function SetupSteps({
  label,
  link,
  steps,
}: {
  label: string;
  link?: React.ReactNode;
  steps: readonly { title: string; detail: React.ReactNode }[];
}) {
  return (
    <YStack className="gap-2">
      <XStack className="items-center justify-between gap-2">
        <span className="text-xs font-medium text-foreground-muted">
          {label}
        </span>
        {link}
      </XStack>
      <ol className="divide-y divide-border overflow-hidden rounded-lg border border-border bg-surface">
        {steps.map((step, index) => (
          <li key={step.title} className="flex items-start gap-3 px-4 py-3">
            <span className="flex size-5 shrink-0 items-center justify-center rounded-full border border-border-strong font-mono text-[10px] text-foreground-muted">
              {index + 1}
            </span>
            <YStack className="min-w-0 gap-0.5">
              <span className="text-sm text-foreground">{step.title}</span>
              <div className="text-xs text-foreground-muted">{step.detail}</div>
            </YStack>
          </li>
        ))}
      </ol>
    </YStack>
  );
}
